export const statsReportsTableEn = {
  expandAllSubtasks: 'Expand all subtasks',
  collapseAllSubtasks: 'Collapse all subtasks',

  attentionCreateMirrorTitle: 'Create a task mirror?',
  attentionCreateMirror:
    'Dragging a task from the summary column creates a mirror'
}

export const statsReportsTableRu: typeof statsReportsTableEn = {
  expandAllSubtasks: 'Развернуть все подзадачи',
  collapseAllSubtasks: 'Свернуть все подзадачи',

  attentionCreateMirrorTitle: 'Создать зеркало задачи?',
  attentionCreateMirror:
    'Перетаскивание задачи из сводной колонки создаёт зеркало'
}
